import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Document } from '@contentful/rich-text-types';

const openpathConfig = require('openpathConfig');

interface MarketingData {
  headline: string;
  backgroundImage: string;
  bodyContent: Document;
  buttonLink: string;
  buttonText: string;
}

const loadMarketingData = async (
  language: string,
  setMarketingData: Dispatch<SetStateAction<MarketingData | undefined>>,
  setIsFetching: Dispatch<SetStateAction<boolean>>,
) => {
  const api = openpathConfig.CONTENTFUL_API_URL;
  const path = '/.netlify/functions/server/splitscreen/';
  const _intent = 'regular';

  const url = `${api}${path}${_intent}/${language}`;
  const response = await fetch(url);
  if (!response.ok) {
    setIsFetching(false);
    return;
  }

  const data = await response.json();

  setMarketingData(data.data);
  setIsFetching(false);
};

export const useMarketing = () => {
  const { i18n } = useTranslation();
  const language = i18n.language || 'en';
  const [marketingData, setMarketingData] = useState<
    MarketingData | undefined
  >();
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    loadMarketingData(language, setMarketingData, setIsFetching);
  }, [language]);

  return { marketingData, isFetching };
};
